import { defineComponent as _defineComponent } from 'vue'


type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: any;
}



const fields = [
  {
    source: 'id',
    link: 'edit',
    sortable: false,
  },
  {
    source: 'language',
    sortable: true,
  },
  {
    source: 'languageCode',
    label: 'Language Code',
    sortable: true,
  },
];

return { __sfc: true,props, fields }
}

})